import { transfer } from 'comlink';
import { createWorker } from '../../utils/workerUtils';
import { AbstractVideoEngine } from './AbstractVideoEngine';
export class StandardVideoEngine extends AbstractVideoEngine {
    LOG_PREFIX = '[StandardVideoEngine]';
    constructor() {
        super();
        console.log(`${this.LOG_PREFIX} constructor called`);
    }
    async addMediaStreamVideoTrack(track) {
        console.log(`${this.LOG_PREFIX} addMediaStreamVideoTrack called`, {
            trackId: track.id,
        });
        await this.workerProxy?.addMediaStreamVideoTrack(transfer(track, [track]));
    }
    async removeMediaStreamVideoTrack(track) {
        console.log(`${this.LOG_PREFIX} removeMediaStreamVideoTrack called`, {
            trackId: track.id,
        });
        await this.workerProxy?.removeMediaStreamVideoTrack(track.id);
        console.log(`${this.LOG_PREFIX} removeMediaStreamVideoTrack completed`, {
            trackId: track.id,
        });
    }
    getWorkerFileName() {
        return 'StandardVideoEngineWorker';
    }
    createWorker() {
        // Not DRY, but otherwise webpack won't transform the worker url
        if (import.meta.env.BUILD_TRANSFORMS_FILENAMES) {
            console.log(`${this.LOG_PREFIX} creating worker with URL constructor`);
            return new Worker(new URL('./StandardVideoEngineWorker.ts', import.meta.url), { type: 'module' });
        }
        console.log(`${this.LOG_PREFIX} creating worker with createWorker util`);
        // Use .ts extension for Vite dev server, .js for production
        const ext = import.meta.env.DEV ? '.ts' : '.js';
        return createWorker(`./StandardVideoEngineWorker${ext}`, import.meta.url);
    }
}
